export default "__VITE_ASSET__Dwz9qv4O__"